import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import ConfigEditor from './pages/ConfigEditor';
import VersionHistory from './pages/VersionHistory';
import Settings from './pages/Settings';
import Login from './pages/Login';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isConfigured, setIsConfigured] = useState(false);

  useEffect(() => {
    const password = localStorage.getItem('qianshu_admin_password');
    const config = localStorage.getItem('qianshu_config');
    setIsAuthenticated(!!password);
    setIsConfigured(!!config);
  }, []);

  // 未登录时显示登录页面
  if (!isAuthenticated) {
    return <Login onLogin={() => setIsAuthenticated(true)} />;
  }

  return (
    <Router>
      {!isConfigured ? (
        <Settings onConfigured={() => setIsConfigured(true)} />
      ) : (
        <Layout>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/config" element={<ConfigEditor />} />
            <Route path="/versions" element={<VersionHistory />} />
            <Route path="/settings" element={<Settings onConfigured={() => setIsConfigured(true)} />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Layout>
      )}
    </Router>
  );
}

export default App;
